import { useEffect, useRef, useState } from "react";

export const useTransition = (isVisible: boolean, delay: number) => {
  const [isDisplay, setIsDisplay] = useState(false);

  const timerNoDisplay = useRef(setTimeout(() => {}));

  useEffect(() => {
    isVisible && setIsDisplay(true);
    !isVisible && (timerNoDisplay.current = setTimeout(() => setIsDisplay(false), delay));

    return () => {
      clearTimeout(timerNoDisplay.current);
    };
  }, [isVisible, delay]);

  return {
    isLiving: isDisplay || isVisible,
    isDisplay: isDisplay && isVisible,
    noDisplay: !isVisible,
  };
};
